export const redactedVariants = {
    initial: {
        transform: "scale3d(1, 1, 1)"
    }, animate: (i) =>({
        transform: "scale3d(0, 1, 1)",
        transition: {
            delay: i[0],
            duration: i[1]
        }
    }), exit: {
        transform: "scale3d(1, 1, 1)"
    }
}